module.exports = __webpack_public_path__ + "img/uploadIcon.f5789f1e.svg";